import { DataFeedDecimals } from './getters/dataFeedDecimals';
import { LatestRoundData } from './getters/latestRoundData';
var ChainLink = {
    getters: {
        DataFeedDecimals: DataFeedDecimals,
        LatestRoundData: LatestRoundData,
    },
};
export { ChainLink };
